import { useTheme } from "@emotion/react";
import {
  CircularProgress,
  LinearProgress,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import SectionMenu from "components/ai-editor/SectionMenu";

export default function SectionContainer({
  section,
  dragHandleProps,
  menuItems,
  children,
  saving = false,
}) {
  const theme = useTheme();

  return (
    <Paper>
      <Stack
        py={2}
        px={4}
        sx={{
          position: "relative",
          minHeight: "50px",
        }}
        justifyContent="center"
      >
        {/* <Typography>{section.index}</Typography> */}
        <div
          style={{
            position: "absolute",
            right: 0,
            top: 0,
          }}
        >
          <SectionMenu section={section} menuItems={menuItems} />
        </div>
        <Stack
          height="100%"
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            color: theme.palette.text.main,
          }}
          alignItems="center"
          justifyContent="center"
          {...dragHandleProps}
        >
          <DragIndicatorIcon />
        </Stack>
        {children}
        {saving && (
          <div
            style={{
              position: "absolute",
              left: 4,
              bottom: 1,
            }}
          >
            <CircularProgress size={12} color="primary" />
          </div>
        )}
      </Stack>
    </Paper>
  );
}
